import React, { useState } from "react";
import { FaLock, FaMinus, FaPlus, FaFileMedical, FaVideo, FaMobileAlt, FaCalendarCheck, FaPrescriptionBottleAlt, FaClock, FaUserCheck, FaHandHoldingUsd, FaHeartbeat, FaHospitalUser, FaChartLine } from "react-icons/fa";

import Medpalm from "../../../assests/Healthsoftware/Telemedicine.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
import { MdBarChart, MdDeveloperMode, MdGroup, MdLocalHospital, MdVerifiedUser, MdVideoCall } from "react-icons/md";
const services = [
    {
        "title": "Virtual Consultations",
        "description": "Facilitate real-time video appointments between patients and healthcare professionals, reducing wait times and improving access to quality care regardless of location. Enables early diagnosis, routine follow-ups, and specialist consultations without the need for in-person visits, enhancing patient convenience and healthcare efficiency."
    },
    {
        "title": "Remote Patient Monitoring (RPM)",
        "description": "Utilizes IoT-enabled medical devices to continuously track patient vitals, chronic conditions, and post-surgical recovery from home. Provides real-time health insights to physicians, allowing for proactive interventions, reducing hospital readmissions, and improving overall patient outcomes."
    },
    {
        "title": "Telepsychiatry",
        "description": "Delivers confidential mental health services through secure video consultations, enabling remote therapy, counseling, and psychiatric evaluations. Expands access to mental health care, particularly for underserved populations, while ensuring privacy and continuity of care for patients requiring ongoing support."
    },
    {
        "title": "E-Prescriptions",
        "description": "Allows healthcare providers to electronically prescribe medications, reducing prescription errors and ensuring faster fulfillment. Integrates with pharmacy systems to streamline medication management, improve adherence, and enhance patient safety by minimizing the risk of drug interactions."
    },
    {
        "title": "Chronic Disease Management",
        "description": "Supports long-term care for conditions such as diabetes, hypertension, and COPD through remote monitoring, AI-powered analytics, and personalized treatment plans. Enables virtual follow-ups and real-time health tracking, helping patients manage their conditions effectively while reducing unnecessary hospital visits."
    },
    {
        "title": "Telemedicine Platform Development",
        "description": "Designs and develops custom telehealth applications tailored to healthcare provider needs. Integrates features such as secure video conferencing, encrypted messaging, electronic health record (EHR) connectivity, AI-driven diagnostics, and remote monitoring capabilities, ensuring a seamless virtual care experience for both patients and providers."
    }
]

const features = [
    { icon: <FaVideo className="text-[#2a627a] text-lg" />, text: "Facilitates high-quality, real-time video consultations between patients and healthcare providers for timely medical advice and diagnoses." },
    { icon: <FaMobileAlt className="text-[#2a627a] text-lg" />, text: "Our telemedicine services are accessible through mobile devices, enabling patients to consult healthcare professionals on-the-go." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Our telemedicine solutions ensure full compliance with HIPAA regulations, providing secure communication and safeguarding patient data." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Provide real-time remote monitoring of patient health metrics, enhancing chronic disease management and improving patient outcomes." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Streamline patient scheduling with automated reminders and follow-ups, improving appointment adherence and reducing missed consultations." },
    // { icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />, text: "E-prescription support for remote medication management." } 
];

const benefits = [
    { icon: <FaClock className="text-[#2a627a] text-lg" />, text: "Provide real-time remote monitoring of patient health metrics, enhancing chronic disease management and improving patient outcomes." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Virtual consultations offer greater convenience for patients, reducing the need for travel and waiting times, leading to improved satisfaction." },
    { icon: <FaHandHoldingUsd className="text-[#2a627a] text-lg" />, text: "Telemedicine reduces the need for in-person visits, minimizing overhead costs for healthcare organizations and making healthcare more affordable for patients." },
    // { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Improves chronic disease management with regular check-ins." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Our telemedicine solutions are scalable, allowing healthcare organizations to expand their virtual care capabilities as needed to accommodate more patients." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "With the ability to provide ongoing care remotely, telemedicine helps improve chronic disease management, reduce hospital readmissions, and provide continuous health monitoring." }
]
const cmsFeatures = [
    { icon: <MdLocalHospital className="text-[#2a627a] text-lg" />, text: "Telemedicine Physician – Provides virtual consultations and remote care, ensuring patients receive timely healthcare services from the comfort of their homes.." },
    { icon: <MdVideoCall className="text-[#2a627a] text-lg" />, text: "Telehealth Coordinator – Manages telemedicine operations and patient scheduling, ensuring smooth coordination between patients and healthcare providers." },
    { icon: <MdVerifiedUser className="text-[#2a627a] text-lg" />, text: "Technical Support Specialist – Ensures seamless technical operation of telemedicine platforms, addressing any system issues and supporting healthcare providers and patients." },
    // { icon: <MdDeveloperMode className="text-[#2a627a] text-lg" />, text: "Telehealth Software Developer – Designs and maintains telemedicine platforms." },
    // { icon: <MdBarChart className="text-[#2a627a] text-lg" />, text: "Healthcare Data Analyst – Uses telemedicine data for performance tracking and improvements." },
    { icon: <MdGroup className="text-[#2a627a] text-lg" />, text: "Patient Engagement Specialist – Focuses on enhancing the virtual care experience for patients, improving their engagement and satisfaction with remote consultations." }
];

const Tele = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full ">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex justify-center items-center">Telemedicine Solutions  - <span className="text-gray-800">Transforming Remote Healthcare</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Enable remote healthcare with secure, real-time virtual consultations and digital health monitoring."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Telemedicine?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Telemedicine refers to the use of digital communication technologies to provide remote healthcare services. This includes virtual consultations, health monitoring, and remote patient care through video calls, chat systems, and online portals. Telemedicine improves accessibility and efficiency, making healthcare more convenient for both patients and providers, while ensuring that all communications remain secure and HIPAA-compliant.
                        </p>
                    </div>
                </section>

                {/* Role in Telemedicine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Telemedicine
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-sm">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Tele;
